import React from 'react'
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from 'react-router-dom'
import Colors from '../helpers/colors'
//import injectTapEventPlugin from 'react-tap-event-plugin'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import reducers from '../reducers'
import { loadState, saveState } from '../helpers/redux'
import PropertiesRouteMiddleware from './tags/RouteMiddleware/PropertiesRouteMiddleware'
import Login from './tags/RouteMiddleware/Login'
import UserAuthentication from './tags/RouteMiddleware/UserAuthentication'
import { getConfiguration } from '../helpers/configuration'
import ScrollToTop from './tags/RouteMiddleware/ScrollToTop'
import CheckForMaintenance from './tags/RouteMiddleware/CheckForMaintenance'
import PreEnrolChecker from './tags/RouteMiddleware/PreEnrolChecker'
import EnrolmentIsClosed from './tags/RouteMiddleware/EnrolmentIsClosed'
import ManageEnrolment from './pages/ManageEnrolment'
import UnitSearch from './pages/UnitSearch'
import LoadNav from './tags/RouteMiddleware/LoadNav'
import ThankYou from './pages/ThankYou'
import Layout from './tags/Layout'
import {
  getAttributeCourseStaticInfo,
  getYearsEnrolled
} from '../helpers/enrolment'
import { isOnboardingCompleted } from '../helpers/steps'
import PreOfferChecker from './tags/RouteMiddleware/PreOfferCheck'
import ParallelLoad from './tags/RouteMiddleware/ParallelLoad'
import OfferLayout from './tags/OfferLayout'
import ManageFinance from "./pages/ManageFinance";

import { ThemeProvider, createTheme } from '@mui/material';

//injectTapEventPlugin()

const muiTheme = createTheme({
  fontFamily: 'Helvetica, Arial',

  palette: {
    primary1Color: Colors.lochmara,
    accent1Color: Colors.lochmara,
    disabledColor: Colors.silver
  },

  stepper: {
    iconColor: Colors.yellowOrange,
    hoveredIconColor: Colors.eggplant,
    inactiveIconColor: Colors.silver
  },
  raisedButton: {
    color: Colors.mineshaft,
    textColor: Colors.yellowOrange,
    primaryColor: Colors.mineshaft,
    primaryTextColor: Colors.yellowOrange
  },
  textField: {
    errorColor: Colors.red
  }
})

const CourseSpecificRoutes = () => {
  return (
    <CheckForMaintenance>
      <ParallelLoad>
        <PreEnrolChecker>
          <Switch>
            <Route
              render={() => {
                return (
                  <EnrolmentIsClosed>
                    <Switch>
                      <Route
                        path={getConfiguration('baseUrl') + '/manage/finance'}
                        exact
                        component={ManageFinance}
                      />
                      <Route
                        path={getConfiguration('baseUrl') + '/units/manage'}
                        exact={true}
                        render={() => (
                          <Redirect
                            to={getConfiguration('baseUrl') + '/manage/units'}
                          />
                        )}
                      />
                      <Route
                        path={getConfiguration('baseUrl') + '/units/manage/add'}
                        component={() => (
                          <Redirect
                            to={getConfiguration('baseUrl') + '/manage/units/add'}
                          />
                        )}
                      />
                      <Route
                        path={getConfiguration('baseUrl') + '/manage/units'}
                        exact
                        component={ManageEnrolment}
                      />
                      <Route
                        path={getConfiguration('baseUrl') + '/manage/units/:year'}
                        exact
                        component={ManageEnrolment}
                      />
                      <Route
                        path={
                          getConfiguration('baseUrl') +
                          '/manage/units/enrolments/add'
                        }
                        component={UnitSearch}
                      />

                      <Route
                        render={() => {
                          return (
                            <LoadNav>
                              <Switch>
                                <Route
                                  path={getConfiguration('baseUrl') + '/thankyou'}
                                  component={ThankYou}
                                />
                                <Route
                                  path={
                                    getConfiguration('baseUrl') + '/units/add'
                                  }
                                  component={UnitSearch}
                                />
                                <Route
                                  render={() =>
                                    getAttributeCourseStaticInfo('isCommencing'
                                    ) === 'Y' || !isOnboardingCompleted() ? (
                                      <Layout />
                                    ) : (
                                      <Redirect
                                        to={{
                                          pathname:
                                            getConfiguration('baseUrl') + '/manage/units'
                                        }}
                                      />
                                    )
                                  }
                                />
                              </Switch>
                            </LoadNav>
                          )
                        }}
                      />
                    </Switch>
                  </EnrolmentIsClosed>
                )
              }}
            />
          </Switch>
        </PreEnrolChecker>
      </ParallelLoad>
    </CheckForMaintenance>
  )
}

const persistedState = loadState()
const store = createStore(reducers, persistedState)

store.subscribe(() => {
  saveState(store.getState())
})

export const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={muiTheme}>
        <Router>
          <Switch>
            <Route
              exact
              path={getConfiguration('baseUrl') + '/login'}
              component={Login}
            />
            <Route path={'/offer'}>
              <UserAuthentication>
                <PropertiesRouteMiddleware>
                  <CheckForMaintenance>
                    <ParallelLoad>
                      <PreOfferChecker>
                        <ScrollToTop>
                          <OfferLayout />
                        </ScrollToTop>
                      </PreOfferChecker>
                    </ParallelLoad>
                  </CheckForMaintenance>
                </PropertiesRouteMiddleware>
              </UserAuthentication>
            </Route>
            <Route path={getConfiguration('publicPath')}>
              <UserAuthentication>
                <PropertiesRouteMiddleware>
                  <ScrollToTop>
                    <CourseSpecificRoutes />
                  </ScrollToTop>
                </PropertiesRouteMiddleware>
              </UserAuthentication>
            </Route>
          </Switch>
        </Router>
      </ThemeProvider>
    </Provider>
  )
}